/**
 * App-surface identifier this app presents to the auth API. The brand app
 * authenticates as the brand owner surface.
 */
export const BRAND_APP_SURFACE = 'brand_owner' as const;
